'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    text-align: left;\n    padding-right: 40px;\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n'], ['\n    text-align: left;\n    padding-right: 40px;\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    color: ', ';\n    ', ';\n    font-family: ', ';\n    font-size: ', ';\n    line-height: ', '; \n    letter-spacing: ', ';   \n\t', '\n'], ['\n    color: ', ';\n    ', ';\n    font-family: ', ';\n    font-size: ', ';\n    line-height: ', '; \n    letter-spacing: ', ';   \n\t', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../../../constants/colors');

var _text = require('../../../constants/text');

var _sizes = require('../../../constants/sizes');

var _label = require('../../../atoms/text/label');

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var List = _styledComponents2.default.ul(_templateObject, function (_ref) {
    var textAlign = _ref.textAlign;
    return textAlign && 'text-align: ' + textAlign + ';';
}, function (_ref2) {
    var right = _ref2.right;
    return right && 'padding-right: ' + (0, _getSize2.default)(right) + 'px;';
}, function (_ref3) {
    var left = _ref3.left;
    return left && 'padding-left: ' + (0, _getSize2.default)(left) + 'px;';
}, function (_ref4) {
    var top = _ref4.top;
    return top && 'margin-top: ' + (0, _getSize2.default)(top) + 'px;';
}, function (_ref5) {
    var bottom = _ref5.bottom;
    return bottom && 'margin-bottom: ' + (0, _getSize2.default)(bottom) + 'px;';
}, function (_ref6) {
    var hideListSymbol = _ref6.hideListSymbol;
    return hideListSymbol && 'list-style-type: none;';
});

var Item = _styledComponents2.default.li(_templateObject2, _colors.Colors.PrimaryText, function (_ref7) {
    var color = _ref7.color;
    return color && 'color: ' + color + ';';
}, _text.TextSizes.ParagraphFontFamily, _text.TextSizes.P1FontSize, _text.TextSizes.P1LineHeight, _text.TextSizes.ParagraphLetterSpacing, function (_ref8) {
    var size = _ref8.size;

    if (size) {
        if (size === _sizes.Sizes.lg) {
            return '\n                    font-size: ' + _text.TextSizes.P1FontSize + ';\n                    line-height: ' + _text.TextSizes.P1LineHeight + ';';
        } else if (size === _sizes.Sizes.md) {
            return '\n                    font-size: ' + _text.TextSizes.P2FontSize + ';\n                    line-height: ' + _text.TextSizes.P2LineHeight + ';';
        } else if (size === _sizes.Sizes.sm) {
            return '\n                    font-size: ' + _text.TextSizes.P3FontSize + ';\n                    line-height: ' + _text.TextSizes.P3LineHeight + ';';
        }
    }
});

var BulletList = function (_React$Component) {
    _inherits(BulletList, _React$Component);

    function BulletList() {
        _classCallCheck(this, BulletList);

        return _possibleConstructorReturn(this, (BulletList.__proto__ || Object.getPrototypeOf(BulletList)).apply(this, arguments));
    }

    _createClass(BulletList, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isMobile = this.context.screen.isMobile;

            return _react2.default.createElement(
                List,
                { top: this.props.top, bottom: this.props.bottom,
                    left: this.props.left, right: this.props.right,
                    textAlign: this.props.textAlign, hideListSymbol: this.props.hideListSymbol },
                this.props.references.map(function (item, index) {
                    return _react2.default.createElement(
                        Item,
                        { key: item.code, size: _this2.props.size, color: _this2.props.color },
                        item.value
                    );
                })
            );
        }
    }]);

    return BulletList;
}(_react2.default.Component);

BulletList.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = BulletList;